import { createBrowserRouter, Outlet, ScrollRestoration } from 'react-router';

import {
  DeceasedProfileModal,
  LayoutWrapper,
  MaintenanceScreenWrapper,
  RouteErrorBoundary,
  RouteWrapper,
  TermsOfUseModal,
} from '@shared/components';
import { TemporaryRedirect } from '@shared/components/V2';
import { ROOT_PATH } from '@shared/constants/paths';
import { LayoutViewContextProvider } from '@shared/context';

import { ROUTES } from '@features/index';

export const router = createBrowserRouter(
  [
    {
      children: [
        ...ROUTES.map(
          ({
            component,
            layoutProps,
            pageType,
            path,
            serviceCatalogCode,
            availableLanguages,
            isNavHeaderHide,
            wogaa,
          }) => ({
            children: [
              {
                Component: () => {
                  const Component = component;

                  return (
                    <MaintenanceScreenWrapper serviceCatalogCode={serviceCatalogCode}>
                      <Component />
                    </MaintenanceScreenWrapper>
                  );
                },
                errorElement: <RouteErrorBoundary />,
                index: true,
              },
            ],
            Component: () => (
              <RouteWrapper path={path} serviceCatalogCode={serviceCatalogCode} wogaa={wogaa}>
                <LayoutWrapper
                  availableLanguages={availableLanguages}
                  isNavHeaderHide={isNavHeaderHide}
                  layoutProps={layoutProps}
                  pageType={pageType}
                  serviceCatalogCode={serviceCatalogCode}
                >
                  <Outlet />
                </LayoutWrapper>
              </RouteWrapper>
            ),
            path,
          })
        ),
        {
          element: <TemporaryRedirect />,
          path: '*',
        },
      ],
      element: (
        <LayoutViewContextProvider ROUTES={ROUTES}>
          <DeceasedProfileModal />
          <TermsOfUseModal />
          <Outlet />
          <ScrollRestoration />
        </LayoutViewContextProvider>
      ),
      errorElement: <RouteErrorBoundary />,
    },
  ],
  {
    basename: ROOT_PATH,
  }
);
